export default "__VITE_ASSET__CHPTwit1__"